/* unplugin-vue-components disabled */import { render } from "./DeviceLocationSettings.vue?vue&type=template&id=04d567d4&ts=true"
import script from "./DeviceLocationSettings.vue?vue&type=script&lang=ts"
export * from "./DeviceLocationSettings.vue?vue&type=script&lang=ts"

import "./DeviceLocationSettings.vue?vue&type=style&index=0&id=04d567d4&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__